module.exports = __webpack_public_path__ + "static/FraktionMono-Medium-447ab40c65539e649610e4283706fcde.woff2";